<template>
  <div class="page">
    <div class="hd">
      <router-link class="backup iconfont iconpre" to="/">
        返回列表
      </router-link>
      <span class="title-mag">{{ title }}</span>
      <span
        class="cale iconfont iconcalendar actable"
        @click.prevent="$emit('caleclick')"
        >過往期刊</span
      >
    </div>

    <slot></slot>
    <slot name="ft"></slot>
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>

<style src="./_layout.css" />;
